var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#131f2a",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,4c-1.024,0 -1.85956,0.77262 -1.97656,1.76563l9.97656,6.23438l9.97656,-6.23437c-0.117,-0.993 -0.95256,-1.76562 -1.97656,-1.76562zM1,7.75195v10.24805c0,1.105 0.895,2 2,2h9.42188h1.57813v-3c0,-0.552 0.448,-1 1,-1h2v-2c0,-0.552 0.448,-1 1,-1h3v-5.24805l-10,6.24805zM19,15v3h-3v2h3v3h2v-3h3v-2h-3v-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NewMessage);
export default __webpack_public_path__ + "static/media/icons8-new-message.c578603e3394c91d652f4ddcab19dd75.svg";
export { ForwardRef as ReactComponent };